'use strict';

//Survey Code and Year constructor

module.exports = function YearCodePrefix(yearCodePIDArray, surveyCodePrefix, resourceType) {
	this.yearPID = yearCodePIDArray;
	this.surveyCodePrefix = surveyCodePrefix;
	this.resourceType = resourceType;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-year-code-pid-prefix.js
// module id = 239
// module chunks = 0